import axios from "axios";

// Create an axios instance with default config

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "",
  timeout: 300000,
  maxBodyLength: Infinity,
  maxContentLength: Infinity,
});

// Add a request interceptor to add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    // Add ngrok bypass header
    config.headers["ngrok-skip-browser-warning"] = "true";

    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Don't set Content-Type for FormData, let the browser handle it
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem("token");
      
      // Only redirect to login if we're not already on the login page
      const currentPath = window.location.pathname;
      if (currentPath !== "/login" && !currentPath.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
